import { useLocation } from 'react-router-dom';
import { parseQueryString } from '../utils/apiUtils';

export function useQueryParams(): Metadata {
  return parseQueryString(useLocation().search);
}
